import { render } from "./boxed-price-lock.vue?vue&type=template&id=2440c972&ts=true"
import script from "./boxed-price-lock.vue?vue&type=script&lang=ts"
export * from "./boxed-price-lock.vue?vue&type=script&lang=ts"

import "./boxed-price-lock.vue?vue&type=style&index=0&id=2440c972&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__